import {BaseDashlet} from "../../lq_js_common/dashboard/base_dashlet";
import {DashboardGraph} from "../../graphs/dashboard_graph";
import {GraphOptionsBuilder} from "../../lq_js_common/e_charts/chart_builder";
import {
    attachDirectionHint,
    applySplitDirectionAxes,
    createBoundedAxisTooltip,
    finalizeSplitDirectionChart,
    formatPercentFromHundredthsAxis,
    formatTimeTick,
} from "../../helpers/chart_common";

export class ShaperRetransmits extends BaseDashlet {
    constructor(slot) {
        super(slot);
        this.rendered = false;
        this.lastGraphState = null;
    }

    title() {
        return "Shaper TCP Retransmits";
    }

    supportsZoom() {
        return true;
    }

    tooltip() {
        return "<h5>Shaper TCP Retransmits</h5><p>Shows the percentage of TCP retransmits over time.</p>";
    }

    buildContainer() {
        let base = super.buildContainer();
        attachDirectionHint(base);
        base.appendChild(this.graphDiv());
        return base;
    }

    setup() {
        super.setup();
        this.graph = new ShaperRetransmitsGraph(this.graphDivId());
        if (this.lastGraphState !== null) {
            this.graph.update(this.lastGraphState);
        }
    }

    channelRequests() {
        return [ "ShaperDetail" ];
    }

    onMessage(msg) {
        if (msg.Data.target !== "shaper_detail") return;

        if (!this.rendered) {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("card", "animate__animated", "animate__fadeIn");
        } else {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("animate__animated", "animate__pulse");
            setTimeout(() => {
                myDiv.classList.remove("animate__animated", "animate__pulse");
            }, 1000);
        }
        for (const [key, value] of Object.entries(msg.Data.blob)) {
            this.graph.update(value);
            this.lastGraphState = value;
        }
    }

}

class ShaperRetransmitsGraph extends DashboardGraph {
    constructor(id) {
        super(id);
        this.option = new GraphOptionsBuilder()
            .withLeftGridSize(75)
            .withTimeAxis()
            .withScaledAbsYAxis("% Retransmits", 50)
            .withEmptyLegend()
            .withEmptySeries()
            .build();
        this.option && this.chart.setOption(this.option);
    }

    update(data) {
        this.chart.hideLoading();

        this.option.legend = { show: false, data: [] };
        applySplitDirectionAxes(this.option, {
            ticks: data.body.ticks || [],
            topLabel: "Download",
            bottomLabel: "Upload",
            yFormatter: formatPercentFromHundredthsAxis,
        });
        this.option.series = [
            { name: "Download", type: "line", data: [], smooth: true, showSymbol: false, xAxisIndex: 0, yAxisIndex: 0 },
            { name: "Upload", type: "line", data: [], smooth: true, showSymbol: false, xAxisIndex: 1, yAxisIndex: 0 }
        ];

        for (let x=0; x<data.body.active_circuits.length; x++) {
            this.option.series[0].data.push(data.body.tcp_retransmits_down_percent[x]);
            this.option.series[1].data.push(0 - data.body.tcp_retransmits_up_percent[x]);
        }

        this.option.tooltip = createBoundedAxisTooltip({
            linkAllXAxes: true,
            yFormatter: formatPercentFromHundredthsAxis,
            formatter: (params) => {
                if (!params || params.length === 0) return "";
                const timeIndex = params[0].dataIndex;
                const downPercent = data.body.tcp_retransmits_down_percent[timeIndex];
                const upPercent = data.body.tcp_retransmits_up_percent[timeIndex];
                return `<div style="font-size: 10px;">
${formatTimeTick(params[0].axisValue)}<br/>
<strong>Download</strong>: ${formatPercentFromHundredthsAxis(downPercent, 2)}<br/>
<strong>Upload</strong>: ${formatPercentFromHundredthsAxis(upPercent, 2)}
</div>`;
            },
        });

        // Add axis pointer configuration for highlighting
        this.option.axisPointer = {
            link: {xAxisIndex: 'all'},
            label: {
                backgroundColor: '#777'
            }
        };

        // Apply
        finalizeSplitDirectionChart(this.option);
        this.chart.setOption(this.option, true);
    }
}
